import { useAtlasStore } from '@/stores/atlasStore';
import { Map, Globe2 } from 'lucide-react';

export function ViewToggle() {
  const viewMode = useAtlasStore((s) => s.viewMode);
  const setViewMode = useAtlasStore((s) => s.setViewMode);

  // 3D view deactivated — only show 2D button
  return (
    <div className="bg-schist rounded-lg shadow-lg shadow-black/20 p-1 flex">
      <button
        onClick={() => setViewMode('2d')}
        className="p-2 rounded-md transition-colors flex items-center gap-1.5 bg-basalt text-limestone"
        title="Vista 2D"
      >
        <Map size={18} />
        <span className="text-xs font-medium">2D</span>
      </button>
    </div>
  );
}
